import {Component} from 'react';
import h from 'react-hyperscript';
import {h4, eyebrow} from 'Components/Typography/Typography';
import {RESOURCE} from 'Src/utils/gtm/const';
import {pushEvent as pushGTMEvent} from 'Src/utils/gtm';
import TooltipGroup from 'Components/TooltipGroup/TooltipGroup';

class TabContent extends Component {
  constructor(props) {
    super(props);
    this.inactiveClasses = 'tab__content';
    this.activeClasses = 'tab__content active';
    this.state = {
      classes: this.inactiveClasses,
    };
  }

  componentDidMount() {
    this.checkClasses();
  }

  componentDidUpdate(prevProps) {
    if (this.props.activeTab !== prevProps.activeTab) {
      this.checkClasses();
    }
  }

  checkClasses() {
    if (Number(this.props.activeTab) === this.props.i) {
      this.setClasses(this.activeClasses);
    } else {
      this.setClasses(this.inactiveClasses);
    }
  }

  setClasses(value) {
    this.setState({
      classes: value,
    });
  }

  render() {
    return (
      h('div', {
        key: `tab-content-${this.props.i}`,
        className: `padding-top--sm ${this.state.classes}`,
        datatab: this.props.i,
      }, [
        h('div', {
          key: `tab-content-row-${this.props.i}`,
          id: `tab-content-row__${this.props.i}`,
          className: 'flex flex--wrap tab-content__row classroom__metrics',
        }, this.props.tab.metrics.map((item, i) => {
          return (
            h('div', {
              key: `${i}__tab-content-row`,
              className: 'padding-right--xl',
            }, [
              h(TooltipGroup, {
                title: item.tooltip,
              }, h(eyebrow, {
                key: `tab-content-row-eyebrow${i}`,
                className: 'padding-bottom--micro',
              }, item.title)),
              h(h4, {
                key: `tab-content-row-left-title-${i}`,
                className: 'flex',
              }, [
                h('span', {
                  className: 'material-icons padding-right--micro',
                }, item.icon),
                this.props[item.id],
              ]),
            ])
          );
        })),
        h('div', {
          key: `tab-resources-${this.props.i}`,
          className: 'classroom__resources',
        }, [
          h(eyebrow, {
            key: `tab-resources-eyebrow-${this.props.i}`,
            className: 'padding-bottom--sm',
          }, this.props.tab.resources.title),
          h('ul', {
            key: `tab-resources-list-${this.props.i}`,
            className: 'list--blank',
          }, this.props.tab.resources.items.map((item, i) => {
            const href = item.href;
            return (
              h('li', {
                key: `tab-resources-list-item${i}`,
              }, h('a', {
                href,
                target: '_blank',
                className: 'text--blue',
                onClick: () => {
                  pushGTMEvent(RESOURCE.TAG, {
                    event: RESOURCE.EVENT,
                    action: {resource_action: RESOURCE.ACTION.RESOURCE_CLICK},
                    variables: {
                      resource_category: 'Classroom Activity',
                      resource_url: href,
                    },
                  });
                },
              }, item.title))
            );
          })),
        ]),
      ])
    );
  }
}

export default TabContent;
